import { createVenue } from '../../../services/api/createVenue'

export async function createVenueWithSlugId(
  token: string,
  body: Record<string, unknown>
): Promise<void> {
  await createVenue(token, { ...body, id: body.venueSlug })
}
